import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { withRouter, Route } from "react-router-dom";
import { find, forEach } from "lodash";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardTitle from "react-md/lib/Cards/CardTitle";
import Button from "react-md/lib/Buttons/Button";

import Server from "./Server";
import Header from "../components/HostServerOrgHeader";
import Table from "../components/host/Table";
import Info from "../components/host/Info";

import { getHost, getServer } from "../actions/resourceActions";
import { setActiveHost } from "../actions/activeActions";
import {DebugElement} from "../Atollon/debug";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Host = ( inputProps ) => {

    let { match, location, history, hosts, setActiveHost } = inputProps;

  const host = find(hosts, h => h.id === match.params.id);

  if (host) {
    if (match.url === location.pathname) {
      return (
        <div className="flex-col">
            <DebugElement text={"src/containers/Host.js"}/>

            <TouchPageHeader
                title={`Host - ${host.name} (${host.address})`}
                buttons={(
                    <Button
                        raised
                        className="btn btn-primary touchButton-2"
                        label="Odstranit hosta"
                        onClick={() => {
                            setActiveHost(host);
                            history.push("/remove-host");
                        }}
                    >delete</Button>
                )}
            />
            <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

            <DebugElement text={"src/containers/Host.js -- Info"}/>
          <Info host={host} initialValues={host} />
            <DebugElement text={"src/containers/Host.js -- Card"}/>
          <Card>
            <CardTitle title="Servery" />
            <CardText>
              <div className="margin-bottom-small">
                <Table history={history} host={host} />
              </div>
              <Button
                icon
                onClick={() => {
                  setActiveHost(host);
                  history.push("/server-found");
                }}
              >
                add
              </Button>
            </CardText>
          </Card>
        </div>
      );
    }
    else
    {
        return (
          <Route
            path={`${match.url}/:id`}
            render={() => <Server history={history} host={host} />}
          />
        );
    }
  }
  return <div />;
};

export default compose(
  withRouter,
  connect(null, { getHost, setActiveHost, getServer }),
  lifecycle({
    async componentWillMount() {
      const { getHost, getServer, match } = this.props;

      await getHost(match.params.id);

      // to get instance count
      {
          let host = find(this.props.hosts, h => h.id === match.params.id); // host which i obtained
          if(host) {
              forEach(host.servers, server => {
                  getServer( host.id, server.id );
              })
          }
      }
    }
  })
)(Host);



// WEBPACK FOOTER //
// ./src/pages/Host.js